export default "__VITE_PUBLIC_ASSET__e6d4e00c__"